module.exports = __webpack_public_path__ + "static/sport/bg.30532e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/september10/bg.jpg
// module id = KgNf
// module chunks = 0